import Button from '@carvana/ds-button';
import { CheckFilledCvna } from '@carvana/ds-icons';
import React, { useEffect } from 'react';
import { Step, StepName } from '|/app/services';
import { useBrandTokens } from '|/brand';
import LinkButton from '|/components/carvana-ds/link-button';
import styles from './task-tile.module.css';
import { getVerificationStepLabel } from '../../get-verification-step-label';

type TileStatus = 'complete' | 'in-progress' | 'not-started';

const CTA_LABEL: Record<TileStatus, string> = {
  complete: 'View',
  'in-progress': 'Continue',
  'not-started': 'Start'
};

interface TaskTileProps {
  step: Step;
  status: TileStatus;
  partialCompletionText: string | null;
  onOpen: () => void;
  onShown?: (stepId: StepName) => void;
}

const TaskTile: React.FC<TaskTileProps> = ({
  step,
  status,
  partialCompletionText,
  onOpen,
  onShown
}) => {
  const tokens = useBrandTokens();

  useEffect(() => {
    onShown?.(step.id);
  }, [onShown, step.id]);

  return (
    <div className={styles.tile}>
      <div className={styles.heading}>
        <div className={styles.info}>
          {status === 'complete' && <CheckFilledCvna size={16} color={tokens.completeIcon} />}
          <span className={styles.name}>{getVerificationStepLabel(step.id, step.name)}</span>
        </div>
        {status === 'complete' ? (
          <LinkButton
            size="sm"
            onClick={onOpen}
            data-analytics-id={`verification-task-tile-view-${step.id}`}
            underline={false}
          >
            View
          </LinkButton>
        ) : (
          <Button
            utility
            size="xs"
            onClick={onOpen}
            data-analytics-id={`verification-task-tile-${status}-${step.id}`}
          >
            {CTA_LABEL[status]}
          </Button>
        )}
      </div>
      {partialCompletionText && <p className={styles.partial}>{partialCompletionText}</p>}
    </div>
  );
};

export default TaskTile;
